import { put, select } from 'redux-saga/effects';
import { selectSocket, setIsConnected, setSocket } from '../../../state/socket/socketSlice';
export function* socketDisconnectSaga() {
    try {
        const socket = yield select(selectSocket);
        if (socket) {
            socket.disconnect();
            yield put(setSocket(null));
            yield put(setIsConnected(false));
            console.log('socket disconnected successfully')
        }
    } catch (error) {
        console.error('Socket disconnection failed:', error);
    }
}